import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconHome = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_515_331)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M0.5 6.5L7.5 0.5L14.5 6.5M6 14.5V10.5H9V14.5M2.5 7V14.5H12.5V7",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_515_331",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 15,
			height: 15,
			fill: "currentColor"
		})
	}) })]
});
export default SvgIconHome;
